import React from 'react';
import shortid from 'shortid';
import Moment from 'react-moment';
import { STATUS_APPLICATION_WAGON } from 'helpers/constants';
import Table from 'components/table';
import Status from 'components/status';
import styles from '../../order.module.scss';

const History = ({ data = [] }) => {
  const cells = [{
    name: 'Редактировал',
    nowrap: true,
    renderField: 'user.inn',
  }, {
    name: 'Дата создания',
    nowrap: true,
    onRender: ({ createdAt }) => <Moment format="DD.MM.YYYY HH:mm:ss">{createdAt}</Moment>,
  }, {
    name: 'Комментарий',
    renderField: 'comment',
  }, {
    name: 'Статус',
    renderField: 'status',
    nowrap: true,
    onRender: (item, value) => (
      <Status
        value={value}
        status={STATUS_APPLICATION_WAGON}
      />
    ),
  }, {
    name: 'Файл',
    onRender: ({ file }) => file.length
      ? file.map(JSON.parse).map(({ link, originalName }) => (
        <div key={shortid.generate()} className={styles.file}>
          <a download href={link}>{originalName}</a>
        </div>
      ))
      : 'Файла нет',
  }];

  return (
    <Table
      className=""
      data={data}
      cells={cells}
    />
  );
};

export default History;
